import { render, staticRenderFns } from "./StockAlertView.vue?vue&type=template&id=7cecfbf2&scoped=true"
import script from "./StockAlertView.vue?vue&type=script&lang=js"
export * from "./StockAlertView.vue?vue&type=script&lang=js"
import style0 from "./StockAlertView.vue?vue&type=style&index=0&id=7cecfbf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cecfbf2",
  null
  
)

export default component.exports